import { TEXTS as en_US } from './en_US'
import { TEXTS as es } from './es'
import { TEXTS as es_PE } from './es_PE'
import { TEXTS as es_PY } from './es_PY'
import { TEXTS as pt_BR } from './pt_BR'

export { en_US, es, es_PY, es_PE, pt_BR }
